import FileTypesField from './FileTypesField';
import PortalFormModal from './PortalFormModal';

import Attention from '../../ReusableComponents/Attention';

import React from 'react';

import { usePortalMutation } from '../hooks';

export default function RequirementForm({ selection, item, defaults, onDone }) {
  const save = usePortalMutation(
    `selecoes/${selection.id}/requisitos${item ? '/' + item.id : ''}`,
    item ? 'PUT' : 'POST'
  );
  return (
    <PortalFormModal
      title={item ? 'Editar documento exigido' : 'Novo documento exigido'}
      onClose={() => onDone()}
      onSubmit={(e) => {
        e.preventDefault();
        const f = new FormData(e.currentTarget);
        save.mutate(
          {
            instructions: f.get('instructions'),
            allowed_types: f.getAll('allowed_types'),
            title: f.get('title'),
            required: f.has('required'),
            max_kb: Math.round(Number(f.get('max_mb')) * 1024),
          },
          {
            onSuccess: (result) => onDone(result?.data),
          }
        );
      }}
      busy={save.isLoading}
      allowed={save.allowed}
      error={save.error}
    >
      <div className="portal-admin-grid">
        <label className="form-label">
          <span className="portal-field-label">
            Documento
            <Attention />
          </span>
          <input
            name="title"
            defaultValue={item?.title ?? defaults?.title}
            className="form-control"
            required
            disabled={!save.allowed}
          />
        </label>
        <label className="form-label">
          <span className="portal-field-label">
            Tamanho máximo (MB)
            <Attention />
          </span>
          <input
            name="max_mb"
            type="number"
            min="0.098"
            max="20"
            step="0.001"
            defaultValue={item ? item.max_kb / 1024 : defaults?.max_kb ? defaults.max_kb / 1024 : 10}
            className="form-control"
            required
            disabled={!save.allowed}
          />
        </label>
      </div>

      <label className="portal-check">
        <input
          name="required"
          type="checkbox"
          defaultChecked={item ? item.required : defaults?.required ?? true}
          disabled={!save.allowed}
        />{' '}
        Obrigatório para confirmar
      </label>

      <label className="form-label">
        <span className="portal-field-label">
          Instruções
          <small className="text-muted">(opcional)</small>
        </span>
        <textarea className="form-control" name="instructions" defaultValue={item?.instructions ?? defaults?.instructions} />
      </label>

      <FileTypesField value={item?.allowed_types ?? defaults?.allowed_types} />
    </PortalFormModal>
  );
}
